export default __webpack_public_path__ + "static/media/FHash6.0deada5d.mp3";